import { useQueryClient } from '@tanstack/react-query';
import type { LucideIcon } from 'lucide-react';
import { tr } from '@/lib/i18n-core';
import { useAuth } from '@/lib/auth';
import { ShellSectionHeading } from '@/components/clinical-shell/ShellPanel';
import { OrderSection } from '../../../opd/emr/orders/OrderSection';
import { admissionIsOpen, type Admission } from '../../admission/types';
import { orderPatientOf } from '../ipd-emr-sections';

export function ProceduresSection({ admission, icon }: { admission: Admission; icon: LucideIcon }) {
  const { can } = useAuth();
  const queryClient = useQueryClient();
  const readOnly = !admissionIsOpen(admission) || !can('order.write');
  const changed = () => {
    void queryClient.invalidateQueries({ queryKey: ['ipd-orders', admission.id] });
    void queryClient.invalidateQueries({ queryKey: ['ipd-tasks', admission.id] });
  };
  return (
    <>
      <ShellSectionHeading icon={icon} title={tr('ipd', 'io_ord_section_procedures')} description={tr('ipd', 'io_ord_desc_procedures')} />
      <OrderSection kind="procedure" scope={{ admissionId: admission.id }} patient={orderPatientOf(admission.patient)} readOnly={readOnly} onChanged={changed} />
    </>
  );
}
